
        $(document).ready(function(){
            setTimeout(function(){
                $('a[href="#looxReviews"]').click(function(event){
                    event.preventDefault(); // Prevent the default anchor click behavior
                    $('html, body').animate({
                        scrollTop: $('.loox-v2-carousel-container').offset().top - 80
                    }, 1000); // Scroll animation duration in milliseconds
                });
            }, 1000); // Delay of 1500 milliseconds (1.5 seconds)
        });
// Set a variable to keep track of whether the script has run
let scriptHasRun = false;

// Wait 1 second before running the script
setTimeout(function() {
  if (!scriptHasRun) {
    // Set the variable to true to indicate that the script has run
    scriptHasRun = true;

    // Run the script
    const accountMenus = $('.accountmenus');
    const subscriptionMenu = $('.subscriptionmenu .pb-5.text-base.font-main');

    if (accountMenus.length && subscriptionMenu.length) {
      console.log("script has been run");
      subscriptionMenu.append(accountMenus);
    }
    
  }
}, 2500);

/*
var headingElement = document.querySelector('#shopify-section-template--16021993685044__1650891033bae15b05 h2.font-heading.heading-effects.heading-template.heading-style.drop_shadow');

// Check if the element exists
if (headingElement) {
    // Change the text content of the element
    headingElement.innerHTML = 'Oat Milk Powder.<br>Just Add Water.';
} else {
    console.error('Element not found.');
}
*/






(() => {
  const STAR_SVG = `
    <svg class="loox-icon custom-loox-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path fill="#f9e700" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2L9.19 8.62L2 9.24l5.45 4.73L5.82 21z"/>
    </svg>
  `.trim();

  function replaceStars(link) {
    const content = link.querySelector('.loox-rating-content');
    if (!content) return;

    // prevent infinite loops
    if (content.dataset.customStarsApplied === 'true') return;

    const label = content.querySelector('.loox-rating-label');

    // remove original stars
    content.querySelectorAll('svg.loox-icon').forEach(el => el.remove());

    // insert 5 stars
    for (let i = 0; i < 5; i++) {
      const wrap = document.createElement('div');
      wrap.innerHTML = STAR_SVG;
      const star = wrap.firstElementChild;

      if (label) content.insertBefore(star, label);
      else content.appendChild(star);
    }

    content.dataset.customStarsApplied = 'true';
    console.log('⭐ Loox stars replaced');
  }

  function scan() {
    document.querySelectorAll('a[href="#looxReviews"]').forEach(link => {
      replaceStars(link);
    });
  }

  // initial run
  scan();

  // observe DOM changes (Loox loads async)
  const observer = new MutationObserver(() => {
    scan();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();